import { render, staticRenderFns } from "./gridMgt.vue?vue&type=template&id=72886ff0&scoped=true&"
import script from "./gridMgt.vue?vue&type=script&lang=js&"
export * from "./gridMgt.vue?vue&type=script&lang=js&"
import style0 from "./gridMgt.vue?vue&type=style&index=0&id=72886ff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72886ff0",
  null
  
)

export default component.exports